import { render } from "./MoviePage.vue?vue&type=template&id=36f5d78c&scoped=true&lang=true"
import script from "./MoviePage.vue?vue&type=script&lang=js"
export * from "./MoviePage.vue?vue&type=script&lang=js"

import "./MoviePage.vue?vue&type=style&index=0&id=36f5d78c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f5d78c"]])

export default __exports__